import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=49a085a2&scoped=true&"
import script from "./sub.vue?vue&type=script&lang=js&"
export * from "./sub.vue?vue&type=script&lang=js&"
import style0 from "./sub.vue?vue&type=style&index=0&id=49a085a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a085a2",
  null
  
)

export default component.exports